module.exports = __webpack_public_path__ + "img/diapositiva-5.c89749d9.png";